import { Collection } from './Collection';
import { SiteModel } from './SiteModel';

export class SiteCollection extends Collection {
  constructor(data) {
    super(data, SiteModel);
  }
}
